import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Cierra el pedido de catálogo (`ventas_en_linea`) al convertir/completar la factura.
 * Sin esto, la cola de Pedidos en línea sigue en `nuevo`/`procesando`.
 */
export async function cerrarPedidoEnLineaPorFactura(
  supabase: SupabaseClient,
  opts: { empresaId: string; facturaId: string; numero?: string | null }
): Promise<void> {
  const empresaId = String(opts.empresaId || '').trim();
  const facturaId = String(opts.facturaId || '').trim();
  if (!empresaId || !facturaId) return;

  const now = new Date().toISOString();
  const patch = { estado: 'completado', updated_at: now };

  const { error: byMeta } = await supabase
    .from('ventas_en_linea')
    .update(patch)
    .eq('empresa_id', empresaId)
    .eq('metadata->>factura_id', facturaId)
    .in('estado', ['nuevo', 'procesando']);
  if (byMeta) {
    console.warn('cerrarPedidoEnLineaPorFactura metadata:', byMeta.message);
  }

  const numero = String(opts.numero || '').trim();
  if (!numero) return;
  const { error: byNumero } = await supabase
    .from('ventas_en_linea')
    .update(patch)
    .eq('empresa_id', empresaId)
    .eq('numero', numero)
    .in('estado', ['nuevo', 'procesando']);
  if (byNumero) {
    console.warn('cerrarPedidoEnLineaPorFactura numero:', byNumero.message);
  }
}
